import * as React from "react"
import { Icon } from "@chakra-ui/react"

export const HamburgerIcon = props => (
  <Icon
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
    xmlSpace="preserve"
    width="1em"
    {...props}
  >
    <path d="M2 5v2h20V5H2zm0 6v2h20v-2H2zm0 6v2h20v-2H2z" />
  </Icon>
)

export default HamburgerIcon
